/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from "react";

interface GPTTestFilterBarProps {
  mediaTypes: any[];
  selectedMediaType: string;
  searchTerm: string;
  onMediaTypeChange: (val: string) => void;
  onSearchChange: (val: string) => void;
  onClearFilters: () => void;
  onSearchClick?: () => void;
}


const GPTTestFilterBar: React.FC<GPTTestFilterBarProps> = ({
  mediaTypes,
  selectedMediaType,
  searchTerm,
  onMediaTypeChange,
  onSearchChange,
  onClearFilters,
  onSearchClick
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-2">
      
      <div className="space-y-2">
        <label className="text-[10px] px-1 font-black text-slate-400 uppercase tracking-widest">
          Media Name
        </label>

        <div className="relative">
          <select
            value={selectedMediaType}
            onChange={(e) => onMediaTypeChange(e.target.value)}
            className="w-full px-5 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs text-slate-500 outline-none focus:bg-white focus:border-[#FF7043] transition-all appearance-none"
          >
            <option value="">All Media Types</option>

            {mediaTypes.map((item: any) => (
              <option key={item.id} value={item.name}>
                {item.name}
              </option>
            ))}
          </select>
          <span className="material-symbols-outlined absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none text-lg">
            expand_more
          </span>
        </div>
      </div>

      <div className="space-y-2 col-span-2">
        <label className="text-[10px] px-1 font-black text-slate-400 uppercase tracking-widest">
          Batch Number
        </label>

        <div className="relative">

          <input
            type="text"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search batch identifier..."
            className="w-full pl-5 pr-12 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs text-slate-700 outline-none focus:bg-white focus:border-[#FF7043] transition-all"
          />

          <span
            className="material-symbols-outlined absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 text-lg cursor-pointer hover:text-[#FF7043]"
            onClick={() => onSearchClick?.()}
          >
            search
          </span>
        </div>
      </div>

      <div className="flex items-end">
        <button
          onClick={onClearFilters}
          className="w-full px-5 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs text-slate-500 outline-none focus:bg-white focus:border-[#FF7043] transition-all appearance-none"
          >
          Reset Filters
        </button>
      </div>
    </div>
  );
};

export default GPTTestFilterBar;